<template>
  <div class="vx-row flex flex-col">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <h3>Pengunjung Tanggal {{$route.params.date}}</h3>
        </div>
        <div class>
          <vs-table :data="histories" stripe @selected="openDetail">
            <template slot="thead">
              <vs-th>No</vs-th>
              <vs-th>Nama Pengunjung</vs-th>
              <vs-th>No Telepon</vs-th>
              <vs-th>Jenis Layanan</vs-th>
              <vs-th>Petugas</vs-th>
              <vs-th>Tipe Pengunjung</vs-th>
              <vs-th>Alamat</vs-th>
              <vs-th>Kabupaten/Kota</vs-th>
              <vs-th>Waktu Kunjungan</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ data.length - indextr }}</vs-td>
                <vs-td :data="tr.name">{{ tr.name }}</vs-td>
                <vs-td :data="tr.phone">{{ tr.phone }}</vs-td>
                <vs-td :data="tr.service">{{ tr.service }}({{tr.agency}})</vs-td>
                <vs-td :data="tr.user">{{ tr.user}}</vs-td>
                <vs-td :data="tr.status">{{ getGuestType(tr.status)}}</vs-td>
                <vs-td :data="tr.address">{{ tr.address}}</vs-td>
                <vs-td :data="tr.location">{{ tr.location}}</vs-td>

                <vs-td :data="tr.created_at">{{tr.created_at }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>

      <vs-button
        @click="$router.push({name: 'riwayat'})"
        color="primary"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
        class="mb-4 self-end"
        size="medium"
      >Kembali</vs-button>

      <vs-popup title="Data Pengunjung" :active.sync="popUp">
        <table class="detail-table">
          <tbody>
            <tr>
              <td class="title">Nomor Unik Kunjungan</td>
              <td>:</td>
              <td>{{popUpData.id}}</td>
            </tr>
            <tr>
              <td class="title">Nama Pengunjung</td>
              <td>:</td>
              <td>{{popUpData.name}}</td>
            </tr>
            <tr>
              <td class="title">Handphone</td>
              <td>:</td>
              <td>{{popUpData.phone}}</td>
            </tr>
            <tr>
              <td class="title">Kota/Kecamatan</td>
              <td>:</td>
              <td>{{popUpData.location}}</td>
            </tr>
            <tr>
              <td class="title">Alamat</td>
              <td>:</td>
              <td>{{popUpData.address}}</td>
            </tr>
            <tr>
              <td class="title">Status Pemohon</td>
              <td>:</td>
              <td>{{popUpData.status}}</td>
            </tr>
            <tr>
              <td class="title">Layanan Dikunjungi</td>
              <td>:</td>
              <td>{{popUpData.service}}</td>
            </tr>
            <tr>
              <td class="title">Keterangan</td>
              <td>:</td>
              <td>{{popUpData.description}}</td>
            </tr>
            <tr>
              <td class="title">Petugas Pelayanan</td>
              <td>:</td>
              <td>{{popUpData.user}}</td>
            </tr>
            <tr>
              <td class="title">Waktu Kunjungan</td>
              <td>:</td>
              <td>{{popUpData.created_at}}</td>
            </tr>
          </tbody>
        </table>
      </vs-popup>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      histories: [],
      guest: {},
      popUp: false,
      popUpData: {
        id: "",
        name: "",
        phone: "",
        address: "",
        status: "",
        description: "",
        service: "",
        agency: "",
        user: "",
        location: "",
        created_at: ""
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$vs.loading();
      this.$http
        .get(`/app/secure/history/${this.$route.params.date}`)
        .then(r => {
          this.histories = r.data.data.histories;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    getGuestType(id) {
      return this.guestTypes.find(i => {
        return i.id == id;
      }).label;
    },
    openDetail(data) {
      this.popUpData = data;
      this.popUp = true;
    }
  },
  computed: {
    ...mapGetters(["guestTypes"])
  }
};
</script>>

<style lang="css" scoped>
.title {
  font-weight: 600;
}

.detail-table td {
  padding: 5px;
}
</style>